import React, { useState } from 'react';
import './WEButton.css';


/**
 * style objects
 */
const basicStyle = {
    backgroundColor: "#01AFDF",
    color: "snow"
}

const WEButton = ({ children,type,onClick,disabled,btnColor = '#01AFDF',style,...props}) => {
    const [hover, setHover] = useState(false);            
    const toggleHover = (e) => {
        let tmp = e;        
        if(hover){
            e.target.classList.remove('hover');
        }else{
            e.target.classList.add('hover');
        }
        setHover(prev => !prev);
    }

    document.documentElement.style.setProperty('--psuedo-bg-color',btnColor);
    

    let btnStyle;
    const defaultStyle = {
        backgroundColor: btnColor ? btnColor : 'transparent',
        color: "snow"
    }
    const outlineType = {
        backgroundColor: 'transparent',
        border: `2px solid ${btnColor}`
    }
    const disabledStyle = {
        cursor: "default",
        opacity: '0.4'
    }

    switch (type) {
        case 'outline':
            btnStyle = outlineType;
            break;
    
        default:
            btnStyle = defaultStyle;
            break;
    }

    return (
        <button
            style={
                disabled ? 
                {...defaultStyle,...btnStyle,...disabledStyle,...style} : 
                {...defaultStyle,...btnStyle,...style}
            }
            className='we-button'
            onMouseEnter={!disabled ? toggleHover : () => {}}
            onMouseLeave={!disabled ? toggleHover : () => {}}
            onClick={!disabled ? onClick : () => {}}
            {...props}
        >
            {children}
        </button>
    );
};

export default WEButton;